/* eslint-disable @typescript-eslint/no-explicit-any */
import { shortenRaceNameV2 } from 'utils/helper';
import InfoBoxContainer from './styled';
import { AVATAR_DEFAULT } from 'assets/images';
import { useAppDispatch } from 'hooks';
import { updateStateModal } from 'features/Profile/profile.slice';

const InfoBox = ({ data }: any) => {
  const dispatch = useAppDispatch()

  const showModalInfo = () => {
    if (data?.user_name) {
      dispatch(updateStateModal({
        isOpen: true,
        userId: data?.id
      }))
    }
  }

  return (
    <InfoBoxContainer>
      <div className='content-box'>
        <div className='img-box'>
          <div className='img-inside'>
            <img src={data?.avatar || AVATAR_DEFAULT} alt="avatar" />
          </div>
        </div>
        <div className='info'>
          <p onClick={showModalInfo} className='name'>{shortenRaceNameV2(data?.user_name)}</p>
          <div className='row-info first'>
            <span>{shortenRaceNameV2(data?.wallet_address)}</span>
          </div>
          <div className='row-info second'>
            <span>{ data?.role ? `GUILD ${data?.role} ` : 'GUEST'}</span>
          </div>
        </div>
      </div>
    </InfoBoxContainer>
  )
}

export default InfoBox;